import React from 'react'
import { DatePickerChangeEvent, DatePicker as Picker, TimePicker, TimePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { Label } from '@progress/kendo-react-labels';

interface IDatePicker {
  label?: any;
  onChange: (date: DatePickerChangeEvent) => void;
  existingDate?: Date;
  readOnly?: boolean;
  required?: boolean;
  size?: 'fullwidth' | 'large' | 'medium' | 'small';
  placeholderText? : any;
  max?: Date;
  min?: Date;
  separateTime?: boolean;
  onDateChange?: (date: DatePickerChangeEvent) => void;
  onTimeChange?: (time: TimePickerChangeEvent) => void
  dateOnly?: boolean;
}

const DatePicker = (props: IDatePicker) => {

  let computedStyle;
  if (props.size === "fullwidth") {
    computedStyle =  400
  } else if (props.size === "large") {
    computedStyle =  300
  } else if (props.size === "medium") {
    computedStyle =  200
  } else if (props.size === "small"){
    computedStyle = 100
  }
  else {
    computedStyle = 400
  }

  const { onChange, existingDate, label, readOnly, required, max, min } = props;
  const defaultValue = existingDate ?? null;

  return (
    <div>
      {label ? (
        <div>
          <Label>{label}</Label>
        </div>
      ) : null}
      {props.separateTime ? (
        <div style={{display:'flex', flexDirection:'row'}}>
          <Picker
            format={"dd-MMM-yyyy"}
            defaultValue={defaultValue}
            width={computedStyle}
            onChange={props.onDateChange}
            disabled={readOnly ?? false}
            required={required ?? false}
            placeholder={props.placeholderText}
            max={max}
            min={min}
          />
          <TimePicker
            format={"hh:mm a"}
            defaultValue={defaultValue}
            width={computedStyle}
            onChange={props.onTimeChange}
            disabled={readOnly ?? false}
            required={required ?? false}
            placeholder={props.placeholderText}
          />
        </div>
      ) : (
        <Picker
          format={!props.dateOnly ? "dd-MMM-yyyy hh:mm a" : "dd-MMM-yyyy"}
          defaultValue={defaultValue}
          width={computedStyle}
          onChange={onChange}
          disabled={readOnly ?? false}
          required={required ?? false}
          placeholder={props.placeholderText}
          max={max}
          min={min}
        />
      )}
    </div>
  )
}

export default DatePicker